const zeroOrString = text => text ? '' + text : text === 0 ? '0' : '';

const charArray = textOrArray => !textOrArray ? []
  : [].map.call(Array.isArray(textOrArray) ? textOrArray : '' + textOrArray, zeroOrString);

const defaultEscapeChar = '\\';

function parseEscapeOptions(text, chars, escapeChar, tokens) {
  return [
    zeroOrString(text),
    charArray(chars),
    zeroOrString(escapeChar) || defaultEscapeChar,
    charArray(tokens),
  ];
}

function _escape(text, chars, escapeChar, tokens) {
  return chars.reduce((text, char, i) =>
      char === escapeChar ? text
        : text.replaceAll(char, `${escapeChar}${tokens[i] || char}`)
    , text.replaceAll(escapeChar, `${escapeChar}${escapeChar}`));
}

function _unescape(text, chars, escapeChar, tokens) {
  return chars.reduce((text, char, i) =>
      char === escapeChar ? text
        : text.replaceAll(`${escapeChar}${tokens[i] || char}`, char)
    , text)
    .replaceAll(`${escapeChar}${escapeChar}`, escapeChar);
}

export function escape(text, chars = '', escapeChar = defaultEscapeChar, tokens = '') {
  return _escape(...parseEscapeOptions(...arguments));
}

export function unescape(text, chars = '', escapeChar = defaultEscapeChar, tokens = '') {
  [ text, chars, escapeChar, tokens ] = parseEscapeOptions(...arguments);
  return _unescape(text, chars.reverse(), escapeChar, tokens.reverse());
}

export function escapes(chars = '', escapeChar = defaultEscapeChar, tokens = '') {
  [ , chars, escapeChar, tokens ] = parseEscapeOptions('', ...arguments);
  const rChars = chars.reverse();
  const rTokens = tokens.reverse();
  return {
    escape: text => _escape(zeroOrString(text), chars, escapeChar, tokens),
    unescape: text => _unescape(zeroOrString(text), rChars, escapeChar, rTokens),
  };
}
